export const PageBlockKeysMap = {
  'first_name': 'name',
  'last_name': 'lastName',
}
